import { Component, inject } from '@angular/core';
import { Router, RouterOutlet, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { NavBarComponent } from './_app/features/home/nav-bar/nav-bar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { AppVersionPanelComponent } from './_jovdk-web/features/app-version-panel/app-version-panel.component';
import { ImageService } from './full-app/ImageService';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        RouterOutlet,
        NavBarComponent,
        FooterComponent,
        AppVersionPanelComponent,
    ],
    templateUrl: './app.component.html',
})
export class AppComponent {
    private readonly _router = inject(Router);
    private readonly _imageService = inject(ImageService);

    private _pendingNavigation = true;
    private _imagesLoadingCount = 0;
    private _overlayHidden = false;

    constructor() {
        this._router.events
            .pipe(takeUntilDestroyed())
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    this._pendingNavigation = true;
                    this.showOverlay();
                }

                if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
                    this._pendingNavigation = false;
                    queueMicrotask(() => this.tryHideOverlay());
                    setTimeout(() => this.tryHideOverlay(), 1500);
                }
            });

        this._imageService.imagesLoading$
            .pipe(takeUntilDestroyed())
            .subscribe((count) => {
                this._imagesLoadingCount = count;
                if (count === 0) {
                    this.tryHideOverlay();
                }
            });
    }

    private showOverlay() {
        const overlay = document.getElementById('boot-overlay');
        if (overlay) {
            overlay.hidden = false;
            overlay.classList.remove('hide-overlay');
        }
        this._overlayHidden = false;
    }

    private tryHideOverlay() {
        if (this._overlayHidden || this._pendingNavigation || this._imagesLoadingCount > 0) {
            return;
        }

        this._overlayHidden = true;

        const overlay = document.getElementById('boot-overlay');
        if (overlay) {
            overlay.classList.add('hide-overlay');
            setTimeout(() => overlay?.remove(), 800);
        }

        const reserve = document.getElementById('lcp-reserved');
        if (reserve) {
            reserve.style.visibility = 'hidden';
            reserve.style.pointerEvents = 'none';
        }
    }
}
